import React, { useRef, useMemo } from "react"
import * as THREE from "three"
import gravel from "./assets/charcoal-84670_1920.jpg" // charcoal-84670_1920.jpg"
// import boulderTexture from "../../images/WM_Stone-Boulder-186_1024.png"

export function GroundTexture({ onLoad }) {
  const ref = useRef()
  const gravelTexture = useMemo(
    () =>
      new THREE.TextureLoader().load(
        gravel,
        () => {
          onLoad("ground")
        },
        e => console.log(e)
      ),
    []
  )
  // const gravelTexture = useLoader(THREE.TextureLoader, gravel, loader => {
  //   loader.load()
  // })
  gravelTexture.wrapS = THREE.RepeatWrapping
  gravelTexture.wrapT = THREE.RepeatWrapping
  gravelTexture.repeat.set(12, 12)
  const material = new THREE.MeshPhysicalMaterial({
    map: gravelTexture,
    bumpMap: gravelTexture,
  })
  // Create ground mesh
  const geometry = new THREE.PlaneBufferGeometry(100, 100)
  return (
    <group ref={ref}>
      <mesh
        args={[geometry, material]}
        rotation={[(Math.PI / 180) * -90, 0, (Math.PI / 180) * -45]}
        position={[0, -2, 0]}
      />
    </group>
  )
}
